<template>
  <q-layout view="hHh lpR fFf">
    <q-header elevated>
      <q-toolbar>
        <q-toolbar-title>
          GLTN
        </q-toolbar-title>
        <q-btn flat round dense icon="mdi-account">
          <q-menu>
            <q-list style="min-width: 100px">
              <q-separator />
              <q-item clickable v-close-popup >
                <q-item-section>Salir</q-item-section>
                <q-item-section avatar>
                  <q-icon name="mdi-exit-to-app" />
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-btn>
      </q-toolbar>
    </q-header>
    <q-page-container>
      <slot />
    </q-page-container>
  </q-layout>
</template>

<script setup>

</script>
